enum ACTIONS {
    FETCH_ALL_CONTACT_MODULES = '[CONTACT_MODULE] - FETCH_ALL',
    PATCH_CONTACT_MODULE = '[CONTACT_MODULE] - PATCH',
    CREATE_CONTACT_MODULE = '[CONTACT_MODULE] - CREATE',
    DELETE_CONTACT_MODULE = '[CONTACT_MODULE] - DELETE'
}

export default ACTIONS;